import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Label,
  Input,
} from "reactstrap";
import SingleNotification from "../../components/Notifications/SingleNotification";
import { GetNotifications } from "../../actions/adminQueries";
import DatePicker from "react-datepicker";
import { formatDate, compareDatesDesc } from "../../Utilities/dateUtils";
import { FormattedMessage } from "react-intl";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import axios from "../../services/api/api";
import { useQueryClient } from "@tanstack/react-query";

export default function Notifications() {
  const notifications = GetNotifications();
  const queryClient = useQueryClient();
  const [notificationData, setNotificationData] = useState([]);
  const [filterStartDate, setFilterStartDate] = useState(null);
  const [filterEndDate, setFilterEndDate] = useState(null);
  const [showOnlyUnread, setShowOnlyUnread] = useState(false);

  const handleMarkAllAsRead = () => {
    let unreadNotifications = (notifications.data ?? []).filter(
      (noti) => !noti.isSeenByMe
    );
    let listOfIdsToMarkAsRead = unreadNotifications.map((item) => {
      return item.notice.id;
    });
    axios
      .post("/User/SetNoticesToRead", { ids: listOfIdsToMarkAsRead })
      .then(() => {
        queryClient.invalidateQueries({ queryKey: ["FetchNotifications"] });
      });
  };

  useEffect(() => {
    let tempNotifications = [...(notifications.data ?? [])];
    tempNotifications = tempNotifications.filter(
      (noti) => !noti.notice.isDeleted
    );
    tempNotifications.forEach((not) => {
      not.notice.showFrom = formatDate(not.notice.showFrom, "yyyy-MM-dd");
    });
    if (showOnlyUnread) {
      tempNotifications = tempNotifications.filter(
        (noti) => noti.isSeenByMe === false
      );
    }
    if (filterStartDate) {
      tempNotifications = tempNotifications.filter(
        (noti) =>
          noti.notice.showFrom >= formatDate(filterStartDate, "yyyy-MM-dd")
      );
    }
    if (filterEndDate) {
      tempNotifications = tempNotifications.filter(
        (noti) =>
          noti.notice.showFrom <= formatDate(filterEndDate, "yyyy-MM-dd")
      );
    }
    tempNotifications = tempNotifications.sort(function (o1, o2) {
      return compareDatesDesc(o1.notice.created, o2.notice.created);
    });

    setNotificationData(tempNotifications);
  }, [
    showOnlyUnread,
    notifications.data,
    filterStartDate,
    filterEndDate,
  ]);

  if (notifications.isPending) {
    return <Pacmanloader />;
  }

  return (
    <>
      <Card style={{ zIndex: "9" }}>
        <CardBody>
          <CardTitle>
            <FormattedMessage id="FilterNotifications" />
          </CardTitle>

          <Row className="px-2 py-2">
            <Col lg="2">
              <Label for="showOnlyUnreadBox">
                <FormattedMessage id="OnlyShowUnread" />
              </Label>
              <Input
                style={{ display: "flex", marginLeft: "0" }}
                name="showOnlyUnreadBox"
                type="checkbox"
                checked={showOnlyUnread}
                onChange={() => setShowOnlyUnread(!showOnlyUnread)}
              ></Input>
            </Col>

            <Col lg="2">
              <Label for="fromDate">
                <FormattedMessage id="FromDate" />
              </Label>
              <DatePicker
                selected={filterStartDate}
                onChange={(value) => setFilterStartDate(value)}
                locale="sv"
                dateFormat="yyyy-MM-dd"
                className="input date--picker"
                wrapperClassName="d-block"
                isClearable
              />
            </Col>
            <Col lg="2">
              <Label for="toDate">
                <FormattedMessage id="ToDate" />
              </Label>
              <DatePicker
                selected={filterEndDate}
                onChange={(value) => setFilterEndDate(value)}
                isClearable
                locale="sv"
                dateFormat="yyyy-MM-dd"
                className="input date--picker"
                wrapperClassName="d-block"
              />
            </Col>
            <Col className="d-flex justify-content-end align-items-start">
              <Button
                outline
                name="buttonMarkAllAsRead"
                color="primary"
                onClick={() => handleMarkAllAsRead()}
              >
                <FormattedMessage id="MarkAllAsRead" />
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>

      {notificationData.map((noti) => {
        return <SingleNotification key={noti.notice.id} notification={noti} />;
      })}
    </>
  );
}
